/**
 * The CMSBlockFull component
 */
import React from "react";
import PropTypes from "prop-types";
import ResponsivePicture from "../../ResponsivePicture";
import LazyLoad from "react-lazyload";

/**
 * Stateless react component to render the CMSBlockFull component
 * @param {Object} props the props passed to the page.
 */
const CMSBlockFull = (props, context) => {
  const { cmsBlock } = props;

  // <Picture
  //           sources={[
  //             { srcSet: webpImgSrcs, type: "image/webp" },
  //             { srcSet: imgSrcs, type: "image/jpeg" }
  //           ]}
  //           sizes="(min-width: 87.5em) 1370px"
  //           alt={cmsBlock.title}
  //           loading="lazy"
  //           />
  return (
    <div className="cmsblock__full">
      {cmsBlock.title && <h2>{cmsBlock.title}</h2>}
      {cmsBlock.subtitle && <p className="lead">{cmsBlock.subtitle}</p>}

      {cmsBlock?.image?.length > 0 && (
        <LazyLoad>
          <ResponsivePicture
            mediumData={{
              sources: cmsBlock.image,
              metadata: {
                width: 1280,
                height: 1280,
              },
            }}
            className="w-100 mb-3"
            altTitle={cmsBlock.title}
          />
        </LazyLoad>
      )}
      {cmsBlock.content && (
        <div dangerouslySetInnerHTML={{ __html: cmsBlock.content }} />
      )}
      {cmsBlock.primary_button_title && cmsBlock.primary_button_target && (
        <a href={cmsBlock.primary_button_target} className="btn btn-primary">
          {cmsBlock.primary_button_title}
        </a>
      )}
      {cmsBlock.secondary_button_title && cmsBlock.secondary_button_target && (
        <a href={cmsBlock.secondary_button_target} className="btn btn-link">
          {cmsBlock.secondary_button_title}
        </a>
      )}
    </div>
  );
};

/** define proptypes for the form */
CMSBlockFull.propTypes = {
  /** the item */
  cmsBlock: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
CMSBlockFull.contextTypes = {
  t: PropTypes.func,
};
export default CMSBlockFull;
